module.exports = __webpack_public_path__ + "static/media/5koloryzacja.95a92638.png";